import {
  Box,
  Collapse,
  Grid,
  IconButton,
  Table,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useState } from "react";

import { FiMoreVertical } from "react-icons/fi";

import { SimpleDialogDelete } from "../../../../components/SimpleDialogDelete/SimpleDialogDelete";
import { OptionsMenu } from "../../components/OptionsMenu";
import { useHistory } from "react-router-dom";
import { GridItem } from "../../components/GridItem";

export function Rows(props) {
  const { row, handleDelete } = props;
  const [open, setOpen] = useState(false);

  const [openDialog, setOpenDialog] = useState(false);
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    handleDelete(row.id);
  };
  const handleEdit = () => {
    history.push(`/cadastro/base/editar/${row.id}`);
  };

  const codTabelaEstoque = !!row.config.codTabelaEstoque
    ? row.config.codTabelaEstoque.split(",").map(Number)
    : null;
  return (
    <>
      <TableRow>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>
          <IconButton
            aria-controls={openMenu ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={openMenu ? "true" : undefined}
            onClick={handleClick}
          >
            <FiMoreVertical />
          </IconButton>
        </TableCell>
        <TableCell>{row.base}</TableCell>
        <TableCell>{row.ip}</TableCell>
        <TableCell>{row.porta}</TableCell>
        <TableCell>{row.portaSql}</TableCell>
        <TableCell>
          <Tooltip title={row.instancia_zapi}>
            <Typography
              maxWidth={"240px"}
              whiteSpace="nowrap"
              overflow="hidden"
              textOverflow="ellipsis"
            >
              {row.instancia_zapi}
            </Typography>
          </Tooltip>
        </TableCell>
        <TableCell>{row.nome_bd_sql}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Informações adicionais
              </Typography>

              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell colSpan={8}>
                      <Grid
                        container
                        rowSpacing={1}
                        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                      >
                        <GridItem
                          value={row.config.codCondicaoPgtoCaixaExpresso}
                          label={"Condição Pgto Caixa Expresso"}
                        />
                        <GridItem
                          value={row.config.codFormaPagamentoBabyMais}
                          label={"Código Baby+"}
                        />
                        <GridItem
                          value={row.config.codTipoVendaDesafio}
                          label={"Código Tipo Venda Desafio"}
                        />
                        <GridItem
                          value={row.config.vendaEntreLojasAtiva}
                          label={"Venda entre Lojas ativa"}
                        />
                        <GridItem
                          value={row.config.codTabelaBiEstoque}
                          label={"Tabela de preços para o bi"}
                        />
                        <GridItem
                          value={row.config.codFormPgtoDescobriuGanhou}
                          label={"Forma de pagamento Descobriu Ganhou"}
                        />
                        <GridItem
                          value={codTabelaEstoque}
                          label={"Tabelas de estoque"}
                        />
                      </Grid>
                    </TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>

      <OptionsMenu
        anchorEl={anchorEl}
        open={openMenu}
        id={row.id}
        onClose={handleClose}
        onDelete={handleClickOpenDialog}
        onEdit={handleEdit}
      />
      <SimpleDialogDelete open={openDialog} onClose={handleCloseDialog} />
    </>
  );
}
